import { useTranslation } from '@pancakeswap/localization'
import { Text } from '@pancakeswap/uikit'
import { SVG, WonSlice, LostSlice, Wrapper, Info } from './PnlChartStyles'

/**
 * Bare minimum chart that doesn't require any external dependencies
 * For details read here - https://www.smashingmagazine.com/2015/07/designing-simple-pie-charts-with-css/
 */

interface PnlChartProps {
  won: number
  lost: number
}

// 2 * Pi * R
const CIRCUMFERENCE = 389.55

const PnlChart: React.FC<React.PropsWithChildren<PnlChartProps>> = ({ lost, won }) => {
  const { t } = useTranslation()
  const percentageWon = (won * 100) / (lost + won)
  const percentageWonDisplay = !Number.isNaN(percentageWon) ? `${percentageWon.toFixed(2)}%` : '0%'
  const paintLost = (lost / (won + lost)) * CIRCUMFERENCE
  const paintWon = CIRCUMFERENCE - paintLost
  return (
    <Wrapper>
      <SVG viewBox="0 0 140 140">
        <LostSlice r="62" cx="70" cy="70" length={paintLost} />
        <WonSlice r="62" cx="70" cy="70" length={paintWon} offset={paintLost} />
      </SVG>
      <Info>
        <Text fontSize="12px" lineHeight="18px">
          {t('Won')}
        </Text>
        <Text fontWeight={700} fontSize="14px" lineHeight="21px">
          {won}/{won + lost}
        </Text>
        <Text fontSize="12px" lineHeight="140%" color="white60">
          {percentageWonDisplay}
        </Text>
      </Info>
    </Wrapper>
  )
}

export default PnlChart
